export const enum ExplorerItemType {
  TRACK = 'TRACK',
  PLAYLIST = 'PLAYLIST',
  TEMPORARY = 'TEMPORARY',
}
